"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translations = exports.SUGGESTIONS_FOOTER_HEIGHT = exports.SUGGESTIONS_BOTTOM_MARGIN = exports.SUGGESTIONS_MAX_HEIGHT = exports.SUGGESTIONS_MIN_HEIGHT = void 0;
exports.SUGGESTIONS_MIN_HEIGHT = 180;
/**
 * NOTE: max height also defined at st.css file
 */
exports.SUGGESTIONS_MAX_HEIGHT = 480;
exports.SUGGESTIONS_BOTTOM_MARGIN = 20;
exports.SUGGESTIONS_FOOTER_HEIGHT = 38;
exports.translations = {
    clearLabel: 'search_box_clear_label',
    searchAll: 'search_box_search_all',
    showAll: 'search_box_suggestions_show_all',
};
//# sourceMappingURL=constants.js.map